module.exports = __webpack_public_path__ + "img/add-coach.174b2eb8.svg";